<template>
  <div class="details">
    <div class="location">
      <span>我的位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>新闻中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="productDetail">
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="20">
          <el-row>
            <el-col :span="6">
              <div class="caseLeft">
                <p class="caseT">相关内容</p>
                <div class="moreCase">
                  <ul class="newsList">
                    <li v-for="(item,index) in newsList" @click="getDetail(item.id)">
                      <div class="newsL">
                        <img :src="settings.apiBaseImg+ item.img" alt="news" />
                      </div>
                      <div class="newsC">
                        <p class="newsTitle">{{item.name}}</p>
                        <p class="newsDate">{{item.create_date}}</p>
                        <p class="newsDesc">{{item.describe}}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </el-col>
            <el-col :span="18" class="contentR">
              <div class="caseLeft textAlign">
                <p class="caseT">{{list.name}}</p>
                <p class="contentDate textAlign">{{list.create_date}}</p>
                <p class="caseContent" v-html="list.content"></p>

                <!-- <img class="casePic" src="../assets/images/product/cased1.png" alt="">
								<p class="caseContent">
									做为可以重复使用的、环保、高效的新型建筑模板材料，他的清洁工作当然也不能落后，传统的抛丸、酸洗、人工清洁的方式完全匹配不上他高大上的性能和效率。
								</p>

								<p class="caseContent">
									做为可以重复使用的、环保、高效的新型建筑模板材料，他的清洁工作当然也不能落后，传统的抛丸、酸洗、人工清洁的方式完全匹配不上他高大上的性能和效率。
								</p>
								<div class="contentList">
									<p class="listTitle">铝模板清洗设备特点</p>
									<ul>
										<li>1.德国进口技术高压泵，不锈钢镀镍合金柱塞，强制水冷降温、强制润滑，能24小时连续作业。</li>
										<li> 2.标准模板、特殊异性件，C槽等均可清洗。</li>
										<li>3.纯高压水物理清洗，流量在23-40L/min.</li>
										<li>4.清洗效率高，自动化清洗设备，不受空间位置限制。</li>
										<li>5.设备可配置其他清洗装置做多种清洗用途。</li>
										<li> 6.设备使用寿命长。</li>
									</ul>
								</div>
								<img class="casePic" src="../assets/images/product/caseb2.png" alt="">
								<div class="contentList bottomj">
									<p class="listTitle">铝模板清洗设备主机整体概况</p>
									<p class="caseContent contentJl">铝模板高压水清洗设备在使用时不需要添加任何的化学试剂，不会对铝模板表面产生磨损还能很好的清除铝模板编码南里清理的混凝土残留，操作简单，可配置变频电机、plc变频电柜，更节能更智能、更安全。这款设备的易损配件少，后期维护简单。</p>
                </div>-->
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import request from "../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      newsList: [],
      list: [],
      id: "",
      name: "",
    };
  },
  created() {
    this.name = this.$route.query.name;
    this.id = this.$route.query.id;
    this.getData();
    this.getDetail(this.id);
    request
      .post(
        this.settings.apiBaseUrl + "/api/index/youhuaseo",
        qs.stringify({}),
        {
          headers: {},
        }
      )
      .then((res) => {
        if (res.code == 1) {
        } else {
          this.$message.error(res.msg);
        }
      });
  },
  methods: {
    getData() {
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/news_link",
          qs.stringify({
            limit: 6,
            type: this.$route.query.name == "公司要闻" ? 1 : 2,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.newsList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    getDetail(id) {
      request
        .post(
          this.settings.apiBaseUrl + "api/index/news_view",
          qs.stringify({
            news_id: id,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.list = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
  },
};
</script>

<style scoped="scoped">
.details {
  width: 100%;
  height: auto;
}

.productDetail {
  margin-top: 80px;
}

.location {
  width: 80%;
  height: 70px;
  margin: 0 auto;
  line-height: 70px;
  text-align: right;
}

.location span {
  line-height: 70px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #b2b2b2;
}

.location /deep/ .el-breadcrumb {
  float: right;
}

.location /deep/.el-breadcrumb__item {
  line-height: 70px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  color: #b2b2b2;
}

/deep/ .el-row {
  width: 100%;
  height: 100%;
}

/deep/ .el-col-20 {
  height: 100%;
}

/deep/ .el-carousel {
  width: 80%;
  height: 80%;
  margin: 10% auto;
}

/deep/ .el-carousel__container {
  height: 100%;
}

.caseLeft {
  width: 100%;
}

.caseLeft .caseT {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.textAlign {
  text-align: center;
}

.project {
  height: 15px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 23px;
  opacity: 0.7;
  margin-bottom: 60px;
}

.caseModel {
  padding-bottom: 50px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.newsList {
  margin-top: 50px;
}

.newsList li {
  width: 100%;
  height: 130px;
  padding: 15px;
  cursor: pointer;
  margin-bottom: 20px;
}

.newsList li:hover {
  background-image: url(../assets/images/news/newb.png);
  background-size: 100% 100%;
}

.newsList li:hover .newsC .newsTitle {
  color: #ffffff !important;
}

.newsList li:hover .newsC .newsDesc {
  color: #ffffff !important;
}

.newsList li:hover .newsDate {
  color: #ffffff !important;
}

.newsList li:hover .newsR p {
  color: #ffffff !important;
}

.newsList .newsL {
  width: 35%;
  height: 100%;
  float: left;
  box-sizing: border-box;
}

.newsList .newsL img {
  width: 100%;
  height: 100%;
}

.newsList .newsC {
  width: 65%;
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding-left: 10px;
}

.newsC .newsTitle {
  height: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #252525;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

.newsDate {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #989898;
  line-height: 17px;
}

.newsC .newsDesc {
  margin-top: 18px;
  height: 40px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8c8c8c;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newsR p {
  height: 22px;
  font-size: 30px;
  font-family: Arial;
  font-weight: bold;
  color: #cccccc;
}

.caseTitle {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 18px;
  text-align: left;
  margin-top: 10px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.caseIntro {
  display: block;
  width: 100%;
  margin-top: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  line-height: 21px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content {
  display: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
  margin: 0 auto;
  background-image: url(../assets/images/home/hoverd.png);
  background-size: 100% 100%;
  padding: 10px 10px;
  box-sizing: border-box;
  left: 0.5%;
}

.content .contentT {
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 18px;
}

.content .contentN {
  margin-top: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.caseContent {
  height: 65px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 23px;
  text-align: left;
}

.caseContentT {
  margin-bottom: 100px;
}

.contentR {
  padding: 0 70px;
}

.casePic {
  width: auto;
  height: auto;
  margin: 60px auto;
}

.contentList .listTitle {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #424242;
  line-height: 23px;
  text-align: left;
}

.contentList ul {
  margin-top: 40px;
}

.contentList ul li {
  text-align: left;

  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7f7f7f;
  line-height: 25px;
}

.contentJl {
  margin-top: 40px;
}

.contentDate {
  height: 12px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 23px;
  margin-top: 30px;
  margin-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/views/newsDetail.vue